'use client';

import { useUser } from '@/hooks/useUser';
import { Box, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
const Sidebar = ({
  closeCB
}: {
  closeCB?: () => void;
}) => {
  const pathname = usePathname();
  const {
    data: user
  } = useUser();
  const isAdmin = !!user?.isAdmin;
  const links = [{
    label: 'Home',
    href: '/'
  }, {
    label: 'Practice Exams',
    href: '/exams'
  }
  // { label: 'My Dashboard', href: '/dashboard' },
  // { label: 'My Account', href: '/dashboard/user-profile' },
  ];
  const adminLinks = [{
    label: 'Admin Dashboard',
    href: '/admin'
  }, {
    label: 'Users',
    href: '/admin/users'
  }, {
    label: 'Stats',
    href: '/admin/daily-stats'
  }];
  const allLinks = isAdmin ? [...links, ...adminLinks] : links;
  return <Box data-sentry-element="Box" data-sentry-component="Sidebar" data-sentry-source-file="Sidebar.tsx">
      <List data-sentry-element="List" data-sentry-source-file="Sidebar.tsx">
        {allLinks.map(link => <ListItem key={link.href} disablePadding>
            <ListItemButton component={Link} prefetch href={link.href} selected={pathname === link.href} onClick={() => {
          closeCB && closeCB();
        }}>
              <ListItemText primary={link.label} />
            </ListItemButton>
          </ListItem>)}
      </List>
    </Box>;
};
export default Sidebar;